module.exports = __webpack_public_path__ + "whitearomaoil.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/whitearomaoil.png
// module id = 884
// module chunks = 0